/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _3_DaysInputs */

const en__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 days before`)
};

const ar__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبل 3 أيام`)
};

const de__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Tage vorher`)
};

const es__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 días antes`)
};

const fr__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 jours avant`)
};

const it__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 giorni prima`)
};

const ja__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3日前`)
};

const ko__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3일 전`)
};

const pt_br__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 dias antes`)
};

const ru__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 3 дня`)
};

const th__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่วงหน้า 3 วัน`)
};

const tr__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 gün önce`)
};

const zh_cn__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提前 3 天`)
};

const zh_tw__3_days = /** @type {(inputs: _3_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提前 3 天`)
};

/**
* | output |
* | --- |
* | "3 days before" |
*
* @param {_3_DaysInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const _3_days = /** @type {((inputs?: _3_DaysInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_3_DaysInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__3_days(inputs)
	if (locale === "ar") return ar__3_days(inputs)
	if (locale === "de") return de__3_days(inputs)
	if (locale === "es") return es__3_days(inputs)
	if (locale === "fr") return fr__3_days(inputs)
	if (locale === "it") return it__3_days(inputs)
	if (locale === "ja") return ja__3_days(inputs)
	if (locale === "ko") return ko__3_days(inputs)
	if (locale === "pt_br") return pt_br__3_days(inputs)
	if (locale === "ru") return ru__3_days(inputs)
	if (locale === "th") return th__3_days(inputs)
	if (locale === "tr") return tr__3_days(inputs)
	if (locale === "zh_cn") return zh_cn__3_days(inputs)
	return zh_tw__3_days(inputs)
});
export { _3_days as "3_days" }